import axios from 'axios'
import { getEntryPeriodUrl, getCheckAllowReferrerUrl, getCreateUuidUrl, getCreateAccountUrl, getMemberCalls2Url } from '@/core/http/http-helper'
import type { TUuidPostBody, TCreateAccountBody, TReferralValidation, TAddressHistoryResponse } from './checkout.types'

export const fetchEntryPeriod = async (countryCode2: string): Promise<string> => {
    const { data } = await axios.get(getEntryPeriodUrl(countryCode2))
    return data.entryPeriod
}

export const validateReferrer = async (countryAlpha3: string, baId: string): Promise<TReferralValidation> => {
    const { data } = await axios.get(getCheckAllowReferrerUrl(countryAlpha3, baId))
    return data
}

export const createUuid = async (body: TUuidPostBody, countryAlpha3: string): Promise<{ uuid: string; success?: boolean }> => {
    const { data } = await axios.post(getCreateUuidUrl(countryAlpha3), body)
    return data
}

export const createAccount = async (body: TCreateAccountBody, countryAlpha3: string): Promise<Record<string, unknown>> => {
    const { data } = await axios.post(getCreateAccountUrl(countryAlpha3), body)
    return data
}

export const fetchAddressHistory = async (baId: string, countryCode: string, token: string): Promise<TAddressHistoryResponse> => {
    const url = getMemberCalls2Url(`etlV2/addressHistory?baId=${baId}&ushopCountryCode=${countryCode}`)
    const { data } = await axios.get(url, {
        headers: { 'Authorization-hydra': `Bearer ${token}` }
    })
    return data
}
